import { ref } from 'vue'
import { get, post } from '../../../utils/index'
import { pgMessage } from '../../message/index'

export default function useDialogScanEpc(options = {}) {
  const epc = ref() // 识别到的自定义序列号
  const { props, beforeEmit } = options

  const __urlRequest = async (otherParams) => {
    const queryMethods = { get, post }
    const request = queryMethods[props.urlMethod]
    const params = { ...props.urlParamter, ...otherParams }

    params.parameters.epc = epc.value

    if (!props.url) return
    if (request) {
      const [res] = await request(props.url, params)

      if (res.code === 200 && res.data) {
        return res.data
      } else {
        // 提示错误信息
        pgMessage.error('未匹配到明细')

        return
      }
    } else {
      throw new Error('请求方法不存在')
    }
  }

  // 查询
  const __queryData = async () => {
    const resData = await __urlRequest()
    console.log('resData: ', resData)

    if (resData && beforeEmit) {
      const flag = await beforeEmit({ epc: epc.value, selectData: resData }, props.beforValueAction)
      console.log('flag: ', flag)

      if (flag) {
        if (flag?.msg) {
          pgMessage[flag?.success ? 'success' : 'error'](flag.msg)
        } else {
          pgMessage.success('拣选成功')
        }
      } else {
        pgMessage.error('未匹配到明细')
      }
    }
  }

  const onScan = async (_, { origin }) => {
    epc.value = origin

    if (props.noRequest) {
      if (beforeEmit) {
        await beforeEmit({ epc: epc.value }, props.beforValueAction)
      }
      return
    }

    await __queryData()
  }

  return { onScan }
}
